// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8168a10f","455":"cd6f288c","977":"1c92f2ad"}[chunkId] + ".chunk.js";
};